import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-stone-50 px-4 text-center">
      <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-full border border-amber-200 bg-amber-50 text-amber-500">
        <i className="fa-solid fa-lock text-4xl" />
      </div>
      <h1 className="text-6xl font-semibold tracking-tight text-slate-800">403</h1>
      <h2 className="mt-4 text-2xl font-semibold text-slate-700">Adgang nægtet</h2>
      <p className="mt-2 max-w-md text-slate-500">
        Du har ikke tilladelse til at tilgå denne ressource eller side.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="rounded-full bg-brand-orange px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-brand-orange-hover"
        >
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="rounded-full border border-stone-200 bg-white px-6 py-3 text-sm font-bold text-slate-700 transition-colors hover:border-brand-orange hover:text-brand-orange"
        >
          Kontakt support
        </Link>
      </div>
    </div>
  );
}
